export const initialState = {
    loading: false,
    brand:null,
    brands: [],
    response: { message: null, error: null },
    
}